import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en/translation.json';
import es from './es/translation.json';
import fi from './fil/translation.json';
import hi from './hi/translation.json';
import id from './id/translation.json';
import ko from './ko/translation.json';
import ms from './ms/translation.json';
import pt from './pt/translation.json';
import sw from './sw/translation.json';
import th from './th/translation.json';
import ja from './ja/translation.json';

function getLang() {
    const lang =
        localStorage.getItem('language') || window.navigator.language || 'en';

    if (lang.includes('es')) {
        return 'es';
    }
    if (lang.includes('ms')) {
        return 'ms';
    }
    if (lang.includes('sw')) {
        return 'sw';
    }
    if (lang.includes('pt')) {
        return 'pt';
    }
    if (lang.includes('id')) {
        return 'id';
    }
    if (lang.includes('hi')) {
        return 'hi';
    }
    // if (lang.includes('th')) {
    //     return 'th';
    // }
    if (lang.includes('fi')) {
        return 'fi';
    }

    if (lang.includes('ko')) {
        return 'ko';
    }
    if (lang.includes('ja')) {
        return 'ja';
    }
    return 'en';
}
const lang = getLang();

i18next.use(initReactI18next).init({
    lng: lang, // if you're using a language detector, do not define the lng option
    debug: true,
    resources: {
        en: { translation: en },
        es: { translation: es },
        ms: { translation: ms },
        sw: { translation: sw },
        pt: { translation: pt },
        hi: { translation: hi },
        id: { translation: id },
        th: { translation: th },
        fi: { translation: fi },
        ko: { translation: ko },
        ja: { translation: ja },
    },
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
});
